import { createFileRoute } from '@tanstack/react-router';
import { NotFoundPage } from '@/pages/errors/ui/NotFoundPage';

/**
 * 404 Not Found ルート定義
 *
 * App層の責務:
 * - URLパス `/404` を NotFoundPage にマッピング
 * - ページが見つからない時の表示
 * - TanStack Router のファイルベースルーティング
 */
export const Route = createFileRoute('/404')({
  component: NotFoundPage,
});
